import styled from 'styled-components';

export const Button = styled.button`
  background: none;
  outline: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px;

  &:hover {
    background-color: #00f3ffbd;
  }

  &.active-animation {
    background-color: #00f3ffbd;
    animation: flickerAnimation 2s infinite;
  }

  &.active {
    background-color: #00f3ffbd;
  }

  @keyframes flickerAnimation {
    0%   { background-color: #00f3ffbd; }
    50%  { background-color: #00f3ff00; }
    100% { background-color: #00f3ffbd; }
  }
`;

export const Mode = styled.button`
  background: none;
  outline: none;
  padding: 5px;
  color: #fff;
  border-radius: 3px;

  &.active {
    background-color: #00f3ffbd;
  }
`;
